import React from 'react';
import './SuperAdminBanner.css';

const SuperAdminBanner = ({ currentUser, onExitView }) => {
  if (!currentUser || !currentUser.isSuperAdminView) {
    return null;
  }

  return (
    <div className="super-admin-banner">
      <div className="banner-content">
        <span className="material-symbols-outlined">admin_panel_settings</span>
        <div className="banner-text">
          <strong>Super Admin View</strong>
          <span>Viewing {currentUser.companyName} as {currentUser.name}</span>
        </div>
      </div>
      <button className="exit-view-btn" onClick={onExitView}>
        <span className="material-symbols-outlined">exit_to_app</span>
        Return to Dashboard
      </button>
    </div>
  );
};

export default SuperAdminBanner;